import React from 'react';
import PropTypes from 'prop-types';
import { useUrl } from './Hooks';
import { matchedPath } from './Utils';

const LinkProps = {
	as: PropTypes.elementType,
	to: PropTypes.string.isRequired,
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
	activable: PropTypes.bool,
	nested: PropTypes.bool,
	state: PropTypes.object,
	className: PropTypes.string
};

const LinkDefault = {
	as: 'a',
	activable: true,
	nested: false,
};

export const Link = ({ as: Component, to, label, activable, nested, state, className, ...props }) => {
	const { url, setUrl } = useUrl();

	const handleClick = (e) => {
		props.onClick && props.onClick(e);
		e.preventDefault();
		setUrl(to, url === to, state);
	};

	const handleMouseDown = () => false;
	
	const { isMatched } = matchedPath(to, url, true, nested);
	
	return (
		<Component
			{...props}
			className={className || (activable && isMatched) ? `${className ? className : ''}${activable && isMatched ? ' active' : ''}`.trim() : undefined}
			href={to}
			data-activable={activable}
			onClick={handleClick}
			onMouseDown={handleMouseDown}>
			{label}
		</Component>
	);
};

Link.propTypes = LinkProps;
Link.defaultProps = LinkDefault;
